import axios from 'axios';
// config
// import { HOST_API } from '../config';
// https://thelaundryportal.com/api/api/
// https://thelaundryportal.com/api/api/

// ----------------------------------------------------------------------

const axiosInstance = axios.create({
  baseURL: 'http://backendlaundryapi.thelaundryportal.com/api'
  // baseURL: 'https://thelaundryportal.com/api/api/'
});


axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => Promise.reject((error.response && error.response.data) || 'Something went wrong')
);

export default axiosInstance;
